import { Injectable, signal } from '@angular/core';
import { UploadProgressState } from '../../shared/utils/batch-upload.util';

/**
 * App-wide sink for in-progress concurrent file uploads, mirrored by a fixed, always-visible
 * widget (`UploadProgressToastComponent`, mounted once in `app.html`) — so the aggregate
 * "N of total done, X%" stays on screen regardless of which page/modal started the upload or
 * where the user scrolls to.
 */
@Injectable({ providedIn: 'root' })
export class UploadProgressService {
  readonly progress = signal<UploadProgressState | null>(null);
}
